<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VnQPoT/tc-custom/9781528962391.jpg?1682168954641" alt="This image is the cover for the book Another World, Another Dimension"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Another World, Another Dimension
      </h1>
      <p class="bookDescription body article font2">
        <p>Who are you really and where did you come from, besides the obvious biological details? Do you believe in a higher power from a higher dimension, or do you never really seriously question your existence? Well, this story is a journey of self-discovery, entering into a spiritual world unknown, a world unseen, a world in another dimension. This story is about a young girl who had to learn that everything isn’t always as it seems and that some things may remain hidden for your protection and in other times need to be revealed, in order to save you. “The world we see and experience with our natural senses is not the reality that really exists. This short novel gives us a peek into the life of a supernatural child, the world of mental illness and the battle that rages between light and darkness. As a prophet of God, with many supernatural experiences and the gift of spiritual sight, I could relate to all that was said in this piece, yet I am not sure if it was my experience of this sort of reality that had me on the edge of my seat or the story that I was reading. Come and join Jessica, a young girl that will open up this brave new world to you the reader.” – Matthew Robert Payne Author and Prophet</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rose-Angela Cox
      </h2>
      
      <p class="authorDescription body article">Having a Christian background has greatly influenced her spiritual beliefs and deep-rooted faith. She grew up singing in the church choir and teaching Sunday school. Both her parents were ordained full-time ministers of the gospel. Driven by purpose, passion, and inspiration, she seeks to reach out to humanity through her writings. She believes we are all on a journey of new discoveries about the self, life, and spirituality.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4547c2d9